import { makeAutoObservable, runInAction } from 'mobx'
import { CategoryList, OwnedProduct, Toast } from '../constants'
import RootStore from './root'
import { SingleSubStore, TermsSubStore } from './subStore'
import { getParamErrorMessage, getServerErrorMessage } from '../utils'
import axios from 'axios'
import type { components, operations } from '../constants/schema'

export class CommonStore {
  rootStore: RootStore
  activeTab = 'home'
  isShowTab = false
  listTab = ''
  errorMessage = ''
  isLoading = false
  minAppVersion = ''
  minBuildNumber = ''
  appVersion = ''
  buildNumber = ''
  invalidAccess = false

  // 유저 예치금 조회
  currentBalance = new SingleSubStore<{ balance: number }>(`/user/current/balance`)

  // 카테고리 목록 조회
  categoryList = new SingleSubStore<CategoryList>(`/product/categories/list`)

  // 보유한 프로덕트 정보 조회
  getOwnedProduct = new SingleSubStore<OwnedProduct>(
    (param?: Record<string, any>) => `/purchase/ownedProduct/${param?.productId}`,
  )

  // 약관 목록 조회
  termsListStore = new TermsSubStore<components['schemas']['TermsDto'][]>(
    (param?: Record<string, any>) => `/terms/page/${param?.pageName}`,
  )
  // 약관 상세 조회
  termsDetailStore = new SingleSubStore<components['schemas']['TermsDto']>(
    (param?: operations['TermsController_findOne']['parameters']['path']) => `/terms/${param?.id}`,
  )

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore
    makeAutoObservable(this)
  }

  setIsLoading = (loading: boolean) => {
    runInAction(() => {
      this.isLoading = loading
    })
  }

  // 하단 tab 표시 여부 설정
  setShowTab = (isShowTab: boolean) => {
    runInAction(() => {
      this.isShowTab = isShowTab
    })
  }

  setActiveTab = (category: string) => {
    runInAction(() => {
      this.activeTab = category
    })
  }

  // error handler
  setError = (presentToast: ({ message, type }: Toast) => void, err: unknown, message?: string) => {
    if (axios.isAxiosError(err)) {
      const resErrorCode = err.response?.data.CODE.code
      // param error
      if (err.response?.status === 400) {
        // 추후 NH 관련 error message control할 때 사용
        // if (err.response?.data.CODE.indexOf('NH_') != -1) {
        //   return presentToast({ message: `[농협 에러] ${err.response?.data.message}`, type: 'fail' })
        // }
        if (getParamErrorMessage(resErrorCode)) {
          return presentToast({ message: String(getParamErrorMessage(resErrorCode)), type: 'fail' })
        }
        return presentToast({ message: err.response?.data.message, type: 'fail' })
      }
      // server error
      if (err.response?.status === 500) {
        // 추후 NH 관련 error message control할 때 사용
        // if (err.response?.data.CODE.indexOf('NH_') != -1) {
        //   return presentToast({ message: `[농협 에러] ${err.response?.data.message}`, type: 'fail' })
        // }
        if (getServerErrorMessage(resErrorCode)) {
          return presentToast({ message: String(getServerErrorMessage(resErrorCode)), type: 'fail' })
        }
        return presentToast({ message: err.response?.data.message, type: 'fail' })
      }
    } else {
      return presentToast({ message: message || '알 수 없는 에러입니다.', type: 'fail' })
    }
    return presentToast({ message: '알 수 없는 에러입니다.', type: 'fail' })
  }

  setMinAppVersion = (minAppVersion: string) => {
    this.minAppVersion = minAppVersion
  }

  setMinBuildNumber = (minBuildNumber: string) => {
    this.minBuildNumber = minBuildNumber
  }

  setBuildNumber = (buildNumber: string) => {
    this.buildNumber = buildNumber
  }

  setAppVersion = (appVersion: string) => {
    this.appVersion = appVersion
  }

  setInvalidAccess = (access: boolean) => {
    runInAction(() => {
      this.invalidAccess = access
    })
  }
}
